import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'
import {
  INVENTORY_ADJUSTMENT_SET_ADJUSTMENT_DETAIL,
  INVENTORY_ADJUSTMENT_SET_ADJUSTMENTS,
  INVENTORY_ADJUSTMENT_SET_OUTLETS,
  INVENTORY_ADJUSTMENT_SET_CURRENT_PAGE,
  INVENTORY_ADJUSTMENT_SET_TOTAL_PAGE,
  INVENTORY_ADJUSTMENT_OPEN_RIGHT_COLUMN,
  INVENTORY_ADJUSTMENT_CLOSE_RIGHT_COLUMN,
  INVENTORY_ADJUSTMENT_SHOW_ADD_ITEMS_MODAL,
  INVENTORY_ADJUSTMENT_HIDE_ADD_ITEMS_MODAL,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEMS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_INGREDIENTS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_SELECTED_ID,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_LOADING,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_LOADING,
  INVENTORY_ADJUSTMENT_SHOW_CONFIRM_SUBMIT_MODAL,
  INVENTORY_ADJUSTMENT_HIDE_CONFIRM_SUBMIT_MODAL,
  INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENTS,
  INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENT_DETAIL,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT,
  INVENTORY_ADJUSTMENT_SHOW_IMPORT_MODAL,
  INVENTORY_ADJUSTMENT_HIDE_IMPORT_MODAL,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_TOTAL_PAGE,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_CURRENT_PAGE,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_KEYWORD,
  INVENTORY_ADJUSTMENT_SET_SUMMARY_INVENTORY_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_SET_SUMMARY_INGREDIENT_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEM_HAS_RECIPE
} from 'actions/inventory/adjustment/constants'
let initialState = {
  outlets: [],
  adjustments: [],
  ingredientAdjustments: [],
  openRightColumn: false,
  adjustmentDetail: null,
  ingredientAdjustmentDetail: null,
  currentPage: null,
  totalPage: null,
  showAddItemsModal: false,
  addItems: {
    items: [],
    ingredients: [],
    isLoading: false,
    selectedId: null,
    alreadyAddedAlert: false,
    currentPage: null,
    totalPage: null,
    keyword: null,
    itemHasRecipe: false
  },
  showConfirmSubmitModal: false,
  showImportModal: false,
  summaryAdjustment: {
    totalCount: 0,
    totalExpense: 0,
    totalIncome: 0,
    totalItems: 0
  },
  summaryIngredientAdjustment: {
    totalCount: 0,
    totalExpense: 0,
    totalIncome: 0,
    totalIngredients: 0
  }
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  let {type, payload} = action

  switch (type) {
    case INVENTORY_ADJUSTMENT_OPEN_RIGHT_COLUMN:
      return {...state, openRightColumn: true}
    case INVENTORY_ADJUSTMENT_CLOSE_RIGHT_COLUMN:
      return {...state, openRightColumn: false}
    case INVENTORY_ADJUSTMENT_SET_ADJUSTMENTS:
      return {...state, adjustments: payload.adjustments}
    case INVENTORY_ADJUSTMENT_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case INVENTORY_ADJUSTMENT_SET_ADJUSTMENT_DETAIL:
      return {...state, adjustmentDetail: payload.adjustment}
    case INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENT_DETAIL:
      return {...state, ingredientAdjustmentDetail: payload.ingredientAdjustment}
    case INVENTORY_ADJUSTMENT_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.page}
    case INVENTORY_ADJUSTMENT_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.page}
    case INVENTORY_ADJUSTMENT_SHOW_ADD_ITEMS_MODAL:
      return {...state, showAddItemsModal: true}
    case INVENTORY_ADJUSTMENT_HIDE_ADD_ITEMS_MODAL:
      return {...state, showAddItemsModal: false}
    case INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEMS:
      return {...state, addItems: {...state.addItems, items: payload.items}}
    case INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_INGREDIENTS:
      return {...state, addItems: {...state.addItems, ingredients: payload.ingredients}}
    case INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_LOADING:
      return {...state, addItems: {...state.addItems, isLoading: true}}
    case INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_LOADING:
      return {...state, addItems: {...state.addItems, isLoading: false}}
    case INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_SELECTED_ID:
      return {...state, addItems: {...state.addItems, selectedId: payload.id}}
    case INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT:
      return {...state, addItems: {...state.addItems, alreadyAddedAlert: true}}
    case INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT:
      return {...state, addItems: {...state.addItems, alreadyAddedAlert: false}}
    case INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_TOTAL_PAGE:
      return {...state, addItems: {...state.addItems, totalPage: payload.page}}
    case INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_CURRENT_PAGE:
      return {...state, addItems: {...state.addItems, currentPage: payload.page}}
    case INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_KEYWORD:
      return {...state, addItems: {...state.addItems, keyword: payload.keyword}}
    case INVENTORY_ADJUSTMENT_SHOW_CONFIRM_SUBMIT_MODAL:
      return {...state, showConfirmSubmitModal: true}
    case INVENTORY_ADJUSTMENT_HIDE_CONFIRM_SUBMIT_MODAL:
      return {...state, showConfirmSubmitModal: false}
    case INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENTS:
      return {...state, ingredientAdjustments: payload.ingredientAdjustments}
    case INVENTORY_ADJUSTMENT_SHOW_IMPORT_MODAL:
      return {...state, showImportModal: true}
    case INVENTORY_ADJUSTMENT_HIDE_IMPORT_MODAL:
      return {...state, showImportModal: false}
    case INVENTORY_ADJUSTMENT_SET_SUMMARY_INVENTORY_ADJUSTMENT:
      return {...state, summaryAdjustment: payload.summaryAdjustment}
    case INVENTORY_ADJUSTMENT_SET_SUMMARY_INGREDIENT_ADJUSTMENT:
      return {...state, summaryIngredientAdjustment: payload.summaryIngredientAdjustment}
    case INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEM_HAS_RECIPE:
      return {...state, addItems: {...state.addItems, itemHasRecipe: payload.itemHasRecipe}}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/inventory/adjustment.js